import { ID } from "@/data/types/Basic";
import { FC } from "react";
import { FacetNavigationList } from "./parts/FacetNavigationList";

export const HelloRetailFacetNavigation: FC<{ id: ID }> = () => <FacetNavigationList />